import(/* webpackMode: "eager" */ "/home/interim/frontend/app/services/workload-reduction/page.tsx");
